import React from 'react';
import {
  makeStyles, IconButton, Dialog,
} from '@material-ui/core';
import IdentityVerification from 'components/IdentityVerification';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles(() => ({
  closeDialogBtn: {
    position: 'absolute',
    zIndex: 2,
    right: 0,
    top: 0,
  },
  verificationOverlay: {
    '& .MuiCardContent-root': {
      overflowY: 'scroll',
    },
  },
}));

const VerificationOverlay = ({
  data, setData, submited, continueBtnAtion, openDialog, setOpenDialog, timezoneErrs,
}) => {
  const classes = useStyles();
  const handleClosDialoge = () => {
    setOpenDialog(false);
  };

  return (
    <>
      <Dialog
        open={openDialog}
        onClose={handleClosDialoge}
        fullScreen
        classes={{
          paper: classes.verificationOverlay,
        }}
      >
        <IconButton onClick={handleClosDialoge} className={classes.closeDialogBtn} color="secondary">
          <CloseIcon />
        </IconButton>
        <IdentityVerification
          data={data}
          setData={setData}
          submited={submited}
          timezoneErrs={timezoneErrs}
          loaded
          continueBtnAtion={(e) => continueBtnAtion(e, true)}
        />
      </Dialog>
    </>
  );
};

export default (VerificationOverlay);
